<script setup>
import {createAdController} from '~/utils/ad-controller.mjs';
const props=defineProps({id:String,blockId:String,type:String,minWidth:{type:Number,default:160},maxHeight:Number});
const settings=useState('settings'),boundary=ref(null),target=ref(null);
let controller;
onMounted(()=>{
 if(useRuntimeConfig().public.RATINGS_STAGE)return;
 const blockId=props.blockId??props.id?.replace(/^yandex_rtb_/,'');
 if(!blockId||blockId===props.id)return;
 controller=createAdController({boundary:boundary.value,target:target.value,blockId,type:props.type,minWidth:props.minWidth,maxHeight:props.maxHeight});
 watch(settings,()=>controller.setDisabled(!!settings.value?.disableAdvertising),{immediate:true});
});
onBeforeUnmount(()=>controller?.dispose());
</script>
<template>
 <div ref="boundary" class="uo-ad-boundary">
  <slot />
  <div ref="target" class="w-full uo-ad-target" :id="id"></div>
 </div>
</template>
<style scoped>
.uo-ad-boundary{width:100%;max-width:100%;min-width:0;contain:inline-size;}
.uo-ad-target{width:100%;max-width:100%;min-width:0;}
.uo-ad-boundary[data-ad-fit="checking"]>.uo-ad-target{visibility:hidden;}
.uo-ad-boundary:is([data-ad-fit="disabled"],[data-ad-fit="waiting-width"],[data-ad-fit="unavailable"],[data-ad-fit="resizing"])>.uo-ad-target{display:none;}
</style>
